/**
 * 实名状态  含义
 *    0   未实名
 *    1   已完成实名
 *    2   实名已被解绑。曾经完成过实名，当前无实名
 *    3   当前已提交实名认证申诉，申诉处理中，当前无实名
 *    4   曾提交实名认证申诉，申诉失败，当前无实名
 *    5   暂无
*/
export const NOT_AUTH = 0
export const AUTH_COMPLETE = 1
export const AUTH_UNBIND = 2
export const AUTH_UNDER_APPEAL = 3
export const AUTH_APPEAL_FAIL = 4
export const AUTH_UNKOWN = 5

export const BIZ_PASSPORT = 'passport'
export const BIZ_PASSPORT_DRIVER = 'passport-driver'
export const BIZ_CODE_PASSPORT = 400001
export const BIZ_CODE_PASSPORT_DRIVER = 30105

// 乘客端&司机端上传图片基本配置信息
export const UOPLOAD_POTO_CONG = {
  passenger: {
    type: 'choice',
    quality: 80,
    cut: false // 是否裁剪，手动缩放图片或者裁剪框 双端的体验不一样
  },
  driver: {
    source: 3,
    scene: 1,
    editable: false,
    quality: 100
  }
}
